<template>
  <div>
    <!-- Main content -->
    <section class="content">
      <!-- Info boxes -->
      <div class="row">
        <div
          class="col-md-4 col-sm-6 col-xs-12"
          v-for="item in applists"
        >
          <div
            v-on:click="goToApp(item.appid, item.appname, item.UidPermission)"
            class="info-box"
          >
            <span class="info-box-icon">
              <img
                class="app-list-img"
                v-if="item.appicon == ''"
                src="../../../static/img/img_app_list_icon_default.png"
              >
              <img
                class="app-list-img"
                v-else
                v-bind:src="'https://d.din.bz/'+item.appicon"
              >
            </span>
            <div class="info-box-content">
              <span class="info-box-number">{{item.appname}}</span>
              <!--<span class="info-box-text">{{item.appid}}</span>-->
              <div class="go-to-app">
                Go To
                <i class="fa fa-arrow-circle-right"></i>
              </div>
            </div>
            <!-- /.info-box-content -->
          </div>
          <!-- /.info-box -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->

    <!-- add APP -->
    <router-link
      :to="{path:'addapp', query: {appname: 'Add App'}}"
    >
      <div class="add-app-bgcolor" v-show="isAdmin">
        <span class="btn add-app pull-right">
          <i class="fa fa-plus"></i>
        </span>
      </div>
    </router-link>
    <!-- /add APP -->
  </div>
</template>

<script>
import api from "../../api";
import utils from "../../utils";
import global from "../Global.vue";

export default {
  name: "Project",
  data() {
    return {
      applists: [],
      isAdmin: utils.checkIsSuperAdmin()
    };
  },
  computed: {},
  created() {
    this.$bus.on("searchapp", this.init);
    //      this.$bus.once('once', () => console.log('这个监听器只会触发一次'))
  },
  beforeDestroy() {
    this.$bus.off("searchapp", this.init);
  },
  methods: {
    toGetAllApp() {
      var params = new URLSearchParams();
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/searchbyidapp?_type=json", params)
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status === 1) {
            if (data.Result) {
              this.applists = [];
              var mylist = JSON.parse(
                utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
              );
              for (var i = 0; i < mylist.length; i++) {
                this.applists.push({
                  appid: mylist[i].appid,
                  appname: mylist[i].appname,
                  appicon: mylist[i].appicon,
                  UidPermission: mylist[i].UidPermission
                });
              }
            }
          }
        });
    },
    toSearchApp(key) {
      var params = new URLSearchParams();
      var appname = {
        appname: key
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(appname), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", window.localStorage.getItem("token"));
      }
      api.request("post", "/searchapp?_type=json", params).then(response => {
        var data = response.data;
        /* Checking if error object was returned from the server */
        if (data.Status === 1) {
          if (data.Result) {
            this.applists = [];
            var mylist = JSON.parse(
              utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
            );
            for (var i = 0; i < mylist.length; i++) {
              this.applists.push({
                appid: mylist[i].appid,
                appname: mylist[i].appname,
                appicon: mylist[i].appicon,
                UidPermission: mylist[i].UidPermission
              });
            }
          }
        }
      });
    },
    goToApp(appid, appname, appper) {
      if (window.localStorage) {
        window.localStorage.setItem("appper", appper);
      }
      this.$router.push(
        "/information/app?" + "appid=" + appid + "&appname=" + appname
      );
    },
    init(key) {
      if (utils.isEmpty(key) || utils.isEmpty(key.key)) {
        //        查询所有app
        this.toGetAllApp();
      } else {
        //        根据key查询app
        this.toSearchApp(key.key);
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style>
.info-box {
  /*cursor: pointer;*/
}

.info-box-content {
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

.info-box-text {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// Project.vue?e81dcc78